import { render, staticRenderFns } from "./ScadaThreeSettings.vue?vue&type=template&id=8074fe02&"
import script from "./ScadaThreeSettings.vue?vue&type=script&lang=js&"
export * from "./ScadaThreeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports